import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types';
import { Alert, Button, Card, Col, Container, Form, FormGroup, ListGroup, ListGroupItem, Row } from 'react-bootstrap';
import { Accordion, AccordionItem, AccordionItemButton, AccordionItemHeading, AccordionItemPanel } from 'react-accessible-accordion';
import { useisLoading } from '../../hook/useisLoading';
import Loading from '../../components/common/Loading';

const Billing = (props, context) => {

    // Variable to show/hide "spinner" while loading page.
    const { isLoading, showSpinner, hideSpinner } = useisLoading(false);
    const { isLoading: accordionStack, showSpinner: showAccordionStack, hideAccordionStack } = useisLoading(true);
    
    if (isLoading) {
        return (
            <Loading />  
        )
    } else {
        return ( <>
            <Container fluid className="main-content-container px-4">
                <br/>
                <Row>
                    <Col lg="12">
                        <Card className="mb-4">
                        <Card.Header className="border-bottom pt-2">
                            <h5 className="m-0">{context.t('Month-to-date Summary July 1 - 21, 2022')}</h5>
                            <h6 className="m-0">{context.t('These charges are factored into your account balance.')}</h6>

                            {/* <i className="material-icons mx-3" style={{ float: "right", cursor: "pointer", fontSize: "20px" }} onClick={e => { history.goBack() }}>arrow_back</i> */}
                        </Card.Header>
                        <Card.Body className="pt-1">
                            <Row className="border-bottom py-2 bg-light">
                                <Col sm="6" className="mb-2 mb-sm-0" style={{ paddingTop: "7px" }}></Col>
                            </Row>
                            <br />

                            <Row>
                                <Col lg="12">
                                    <Accordion allowZeroExpanded preExpanded={['a']}>
                                        <AccordionItem uuid="a">
                                            <AccordionItemHeading onClick={ () => {return true} } >
                                                        <AccordionItemButton >
                                                            Plan
                                                        </AccordionItemButton>
                                            </AccordionItemHeading>
                                            <AccordionItemPanel> 
                                                {(accordionStack)?(
                                                    <Container>
                                                        <Row>
                                                            <Col lg="8">Name</Col>
                                                            <Col lg="4">Business</Col>
                                                        </Row>
                                                        <Row>
                                                            <Col lg="8">API Call included</Col>
                                                            <Col lg="4">1.200.000</Col>
                                                        </Row>
                                                        <Row>
                                                            <Col lg="8">Surplus amount per API Call</Col>
                                                            <Col lg="4">USD 0.000200</Col>
                                                        </Row>
                                                        <Row>
                                                            <Col lg="8">Number or CORES included</Col>
                                                            <Col lg="4">8</Col>
                                                        </Row>
                                                        <Row>
                                                            <Col lg="8">Monthly plan (no surplus)</Col>
                                                            <Col lg="4"><strong>USD 300</strong></Col>
                                                        </Row>
                                                    </Container>
                                                ):(null)}
                                            </AccordionItemPanel>
                                        </AccordionItem>
                                    </Accordion>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg="12">
                                    <Accordion allowZeroExpanded>
                                        <AccordionItem uuid="a">
                                            <AccordionItemHeading onClick={ () => {return true} } >
                                                <AccordionItemButton>
                                                    {context.t("Stacks")} <strong className='snx-icon'> (8 CORES used)</strong>
                                                </AccordionItemButton>
                                            </AccordionItemHeading>
                                            <AccordionItemPanel> 
                                                {(accordionStack)?(
                                                    <Container>
                                                        <Row>
                                                            <Col lg="8">ShopOnline</Col>
                                                            <Col lg="4">4 CORE</Col>
                                                        </Row>
                                                        <Row>
                                                            <Col lg="8">Andromeda</Col>
                                                            <Col lg="4">2 CORE</Col>
                                                        </Row>
                                                        <Row>
                                                            <Col lg="8">Application for Customer</Col>
                                                            <Col lg="4">1 CORE</Col>
                                                        </Row>
                                                        <Row>
                                                            <Col lg="8">App Delta</Col>
                                                            <Col lg="4">1 CORE</Col>
                                                        </Row>
                                                    </Container>
                                                ):(null)}
                                            </AccordionItemPanel>
                                        </AccordionItem>
                                    </Accordion>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg="12">
                                    <Accordion allowZeroExpanded>
                                        <AccordionItem uuid="a">
                                            <AccordionItemHeading onClick={ () => {return true} } >
                                                        <AccordionItemButton>
                                                            API Calls <strong className='snx-icon'> (1.805.054)</strong>
                                                        </AccordionItemButton>
                                            </AccordionItemHeading>
                                            <AccordionItemPanel> 
                                                {(accordionStack)?(
                                                    <Container>
                                                        <Row>
                                                            <Col lg="8">ShopOnline</Col>
                                                            <Col lg="4">511.984</Col>
                                                        </Row>
                                                        <Row>
                                                            <Col lg="8">Andromeda</Col>
                                                            <Col lg="4">754.688</Col>
                                                        </Row>
                                                        <Row>
                                                            <Col lg="8">Application for Customer</Col>
                                                            <Col lg="4">487.744</Col>
                                                        </Row>
                                                        <Row>
                                                            <Col lg="8">App Delta</Col>
                                                            <Col lg="4">50.638</Col>
                                                        </Row>
                                                    </Container>
                                                ):(null)}
                                            </AccordionItemPanel>
                                        </AccordionItem>
                                    </Accordion>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg="6">
                                </Col>
                                <Col lg="3">
                                    Excess amount of API Call
                                </Col>
                                <Col lg="3">
                                    (605.054)
                                </Col>
                            </Row>
                            <Row>
                                <Col lg="6">
                                </Col>
                                <Col lg="3">
                                    Excess cost
                                </Col>
                                <Col lg="3">
                                    USD 121,01
                                </Col>
                            </Row>
                            <Row>
                                <Col lg="6">
                                    
                                </Col>
                                <Col lg="3">
                                    Total
                                </Col>
                                <Col lg="3" className='snx-icon'>
                                    <strong>USD 421,01*</strong>
                                </Col>
                            </Row>
                        </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </>)
    }
}

Billing.contextTypes = {
    t: PropTypes.func.isRequired
}


export default Billing